import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDrawer, {
    attrs: {
      value: _setup.value,
      "is-back": _vm.isBack,
      title: _setup.t("Дата и время", _setup.options),
      attach: ".vue-the-doctors-filters .v-application",
    },
    on: { input: _setup.closeModal, back: _setup.closeModal },
    scopedSlots: _vm._u(
      [
        {
          key: "append-header",
          fn: function () {
            return [
              _setup.isVisibleReset
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-auto",
                      attrs: {
                        color: "primary",
                        small: "",
                        text: "",
                        depressed: "",
                      },
                      on: { click: _setup.clickResetBtn },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t("Сбросить", _setup.options)) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "default",
          fn: function () {
            return [
              _c(
                "div",
                { class: _setup.isMobile ? "px-2 py-6" : "pa-6" },
                [
                  _c(_setup.CustomDatepicker, {
                    staticClass: "mb-4",
                    attrs: {
                      value: _setup.selectedDate,
                      interval: "",
                      "weeks-num": 2,
                    },
                    on: { change: _setup.handlePickDate },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        VChip,
                        {
                          staticClass: "mx-1",
                          attrs: { color: "bg-gray-40", "text-color": "text" },
                          on: {
                            click: function ($event) {
                              return _setup.handleClickChip("today")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.t("Сегодня", _setup.options)) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VChip,
                        {
                          staticClass: "mx-1",
                          attrs: { color: "bg-gray-40", "text-color": "text" },
                          on: {
                            click: function ($event) {
                              return _setup.handleClickChip("tomorrow")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.t("Завтра", _setup.options)) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_setup.WEEK_DATES.isTodaySaturday
                        ? _c(
                            VChip,
                            {
                              staticClass: "mx-1",
                              attrs: {
                                color: "bg-gray-40",
                                "text-color": "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _setup.handleClickChip("weekend")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _setup.t("На выходных", _setup.options)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-center text-body-2 text-info--text",
                      class: _setup.isMobile ? "mb-4" : "mb-6",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              "Выберите дату или диапазон",
                              _setup.options
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(VDivider, { class: _setup.isMobile ? "mb-4" : "mb-6" }),
                  _vm._v(" "),
                  !_setup.isMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-center text-subtitle-1 text--text mb-7",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _setup.t("Время посещения", _setup.options)
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_setup.dayTimesCheckboxes, function (checkbox, i) {
                    return _c(
                      _setup.CheckboxTime,
                      {
                        key: i,
                        staticClass: "mt-0 mb-6",
                        class: { "pl-2": !_setup.isMobile },
                        attrs: {
                          value: _setup.selectedTime,
                          multiple: "",
                          "hide-details": "",
                          "selected-value": checkbox.value,
                        },
                        on: { input: _setup.handlePickTime },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "text-body-1 text--text ml-4" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _setup.t(checkbox.name, _setup.options)
                                ) +
                                "\n          "
                            ),
                            _c(
                              "div",
                              { staticClass: "text-secondary--text mt-1" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(checkbox.time) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _vm._t("footer", function () {
                return [
                  _c(_setup.BtnShowDoctors, {
                    staticClass: "pa-2 elevation-8",
                    attrs: { active: _setup.value },
                    on: {
                      "click:close": _setup.closeModal,
                      "click:submit": _setup.handleClickSubmit,
                    },
                  }),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }